import React from "react";
import { Col, FormGroup, Button } from "reactstrap";
import { altaUser, updateUser } from "../requests/req_users";
import { notifica, call_api } from "../requests/utils";

export default class FrmUsuario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isEdit: false,
      perfiles: null,
      values: {
        nombre: null,
        apellidoMat: null,
        apellidoPat: null,
        contrasenia: "triplei1%",
        correo: null,
        idPerfil: null,
        idUsuario: null,
        idEstatus: null,
      },
      required: {
        nombre: {
          message: "Ingresa el nombre del usuario",
        },
        apellidoPat: {
          message: "Ingresa el apellido paterno",
        },
        correo: {
          message: "Ingresa el correo del usuario",
          rgx: {
            pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
            message: "El correo no cumple con una dirección valida",
          },
        },
        idPerfil: {
          message: "Selecciona el perfil del usuario",
        },
      },
    };
    this.guarda = this.guarda.bind(this);
    this.verPass = this.verPass.bind(this);
    this.cambiapass = this.cambiapass.bind(this);
  }

  componentDidMount() {
    this.getPerfiles();
  }

  componentDidUpdate(prevProps, prevState) {
    const { values } = this.state;
    const { data } = this.props;
    if (prevProps.data !== data) {
      if (data.idUsuario) {
        const newState = { ...this.state };
        Object.keys(values).forEach((item) => {
          newState.values[item] = data[item] ? data[item] : null;
        });
        if (data.idUsuario) {
          newState.isEdit = true;
        }
        this.setState(newState);
      } else {
        this.setState({
          values: {
            nombre: "",
            apellidoMat: "",
            apellidoPat: "",
            contrasenia: "",
            correo: "",
            idPerfil: "",
            idUsuario: null,
            idEstatus: null,
          },
          isEdit: false,
        });
      }
    }
  }

  getPerfiles = async () => {
    let result = await call_api({
      endpoint: "system/getProfiles",
      method: "GET",
    });
    if (result && result.code === 0) {
      if (result.data.data) {
        this.setState({ perfiles: result.data.data });
      }
    }
  };

  async guarda(e) {
    const { values, required, isEdit } = this.state;
    const { onSubmit } = this.props;
    let formValit = true;
    let messageError = "";
    if (!isEdit) {
      Object.keys(required).forEach(function (item) {
        if (required[item] && formValit) {
          if (
            values[item] === undefined ||
            values[item] === null ||
            values[item] === ""
          ) {
            formValit = false;
            messageError = required[item].message;
          } else if (values[item] !== undefined && values[item].length > 0) {
            if (required[item].rgx) {
              const { pattern, message } = required[item].rgx;
              if (!pattern.test(values[item])) {
                formValit = false;
                messageError = message;
              }
            }
          }
        }
      });
    } else {
      if (values.idPerfil === null || values.idPerfil === "") {
        formValit = false;
        messageError = "Selecciona el perfil del usuario";
      }
    }

    if (!formValit) {
      notifica("warning", messageError, "Campos obligatorios");
    } else {
      if (!isEdit) {
        altaUser({
          nombre: values.nombre,
          apeP: values.apellidoPat,
          apeM: values.apellidoMat,
          correo: values.correo,
          contrasenia: values.contrasenia,
          idPerfilNegocio: values.idPerfil,
        });
      } else {
        await updateUser({
          idUsuario: values.idUsuario,
          idPerfil: values.idPerfil,
          idEstatus: values.idEstatus,
        });
      }

      this.setState({ values: {} }, () => {
        onSubmit();
      });
    }
  }

  setFieldInput = (field, value) => {
    const newState = { ...this.state };
    newState.values[field] = value;
    newState.values.contrasenia = "triplei1%";
    this.setState(newState);
  };

  verPass(e) {
    var elm = e.target,
      ps = document.getElementById("Inp_Pass"),
      cps = document.getElementById("Inp_CnfPass");
    if (elm.checked) {
      ps.setAttribute("type", "text");
      cps.setAttribute("type", "text");
    } else {
      ps.setAttribute("type", "password");
      cps.setAttribute("type", "password");
    }
  }

  cambiapass(e) {
    var ps = document.getElementById("Inp_Pass"),
      cps = document.getElementById("Inp_CnfPass");
    if (ps.value !== cps.value) {
      ps.classList.add("inp_difrnt");
      cps.classList.add("inp_difrnt");
    } else {
      ps.classList.remove("inp_difrnt");
      cps.classList.remove("inp_difrnt");
    }
  }

  render() {
    const { values, isEdit, perfiles } = this.state;
    return (
      <div className="Frm_Users">
        <FormGroup row>
          <Col sm={3} md={3} lg={3}>
            <label>Nombre:</label>
            <input
              type="text"
              id="Inp_Usuario"
              className="inp_nrml"
              disabled={isEdit}
              onChange={(e) => {
                this.setFieldInput("nombre", e.target.value);
              }}
              value={values.nombre}
            />
          </Col>
          <Col sm={3} md={3} lg={3}>
            <label>Apellido Paterno:</label>
            <input
              type="text"
              id="Inp_Paterno"
              className="inp_nrml"
              disabled={isEdit}
              onChange={(e) => {
                this.setFieldInput("apellidoPat", e.target.value);
              }}
              autoComplete={"off"}
              value={values.apellidoPat}
            />
          </Col>
          <Col sm={3} md={3} lg={3}>
            <label>Apellido Materno:</label>
            <input
              type="text"
              id="Inp_Materno"
              className="inp_nrml"
              disabled={isEdit}
              onChange={(e) => {
                this.setFieldInput("apellidoMat", e.target.value);
              }}
              value={values.apellidoMat}
            />
          </Col>
          <Col sm={3} md={3} lg={3}>
            <label>Perfil:</label>
            <select
              type="text"
              id="Sel_Prfl"
              className="inp_slct"
              onChange={(e) => {
                this.setFieldInput("idPerfil", e.target.value);
              }}
              value={values.idPerfil}
            >
              <option value={""}>Seleccione una opción</option>
              {perfiles
                ? perfiles.map((item) => (
                    <option value={item.idPerfil}>{item.descripcion}</option>
                  ))
                : null}
            </select>
          </Col>

          <Col sm={3} md={3} lg={3}>
            <label>Correo:</label>
            <input
              type="text"
              id="Inp_Correo"
              className="inp_nrml"
              autoComplete={"off"}
              disabled={isEdit}
              onChange={(e) => {
                this.setFieldInput("correo", e.target.value);
              }}
              value={values.correo}
            />
          </Col>
          {!isEdit ? null : (
            <Col sm={2} md={2} lg={2} className="ckF_disable">
              <input
                type="checkbox"
                id="chDisable"
                checked={values.idEstatus}
                onChange={(e) => {
                  this.setFieldInput("idEstatus", !values.idEstatus);
                }}
              />
              <label htmlFor="chDisable">
                <span></span>
              </label>
            </Col>
          )}

          <Col sm={1} md={1} lg={1}>
            <Button color="info" onClick={(e) => this.guarda(e)}>
              {isEdit ? "ACTUALIZAR" : "GUARDAR"}
            </Button>
          </Col>
        </FormGroup>
      </div>
    );
  }
}

/*(
            <>
              <Col sm={3} md={3} lg={3}>
                <label>Contraseña:</label>
                <input
                  type="password"
                  autoComplete={"off"}
                  id="Inp_Pass"
                  className="inp_nrml"
                  onChange={(e) => {
                    this.setFieldInput("contrasenia", e.target.value);
                    this.cambiapass(e);
                  }}
                />
              </Col>
              <Col sm={3} md={3} lg={3}>
                <label>Confirma Contraseña:</label>
                <input
                  type="password"
                  id="Inp_CnfPass"
                  autoComplete={"off"}
                  className="inp_nrml"
                  onChange={(e) => this.cambiapass(e)}
                />
              </Col>
              <Col sm={2} md={2} lg={2} className="ckF">
                <input
                  type="checkbox"
                  id="chVer"
                  onChange={(e) => this.verPass(e)}
                />
                <label htmlFor="chVer">
                  <span></span>
                </label>
              </Col>
            </>
          ) */
